import React from 'react'
import './Header.scss'

const Header = () => {
    return (
        <div className='header'>
            <img className='header-logo' src='https://cdn.worldvectorlogo.com/logos/aviasales-4.svg' alt='logo'/>
        </div>
    )
}

export default Header
